import React, { useEffect, useState } from 'react';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
const argentineCities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'San Miguel de Tucumán', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Resistencia', 'Neuquén', 'Posadas', 'Bahía Blanca'];
const argentineNames = ['Martín González', 'Lucía Fernández', 'Santiago Rodríguez', 'Valentina López', 'Mateo Pérez', 'Sofía Martínez', 'Benjamín García', 'Catalina Romero', 'Joaquín Silva', 'Camila Torres', 'Tomás Díaz', 'Florencia Castro', 'Agustín Morales', 'Victoria Sánchez', 'Lucas Méndez', 'Julieta Vargas'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = argentineNames[Math.floor(Math.random() * argentineNames.length)];
      const randomCity = argentineCities[Math.floor(Math.random() * argentineCities.length)];
      setCurrentPurchase({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    const initialDelay = setTimeout(showPopup, 3000);
    const interval = setInterval(showPopup, 15000);
    return () => {
      clearTimeout(initialDelay);
      clearInterval(interval);
    };
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-6 left-6 z-50 animate-slide-in" data-id="element-285">
      <div className="bg-white rounded-lg shadow-2xl p-4 max-w-sm border-2 border-green-500" data-id="element-286">
        <div className="flex items-start gap-3" data-id="element-287">
          <div className="bg-green-100 rounded-full p-2" data-id="element-288">
            <ShoppingBagIcon className="w-6 h-6 text-green-600" data-id="element-289" />
          </div>
          <div className="flex-1" data-id="element-290">
            <p className="font-bold text-gray-900 text-sm" data-id="element-291">¡Compra reciente!</p>
            <p className="text-gray-700 text-sm" data-id="element-292">
              <span className="font-semibold" data-id="element-293">{currentPurchase.name}</span> de{' '}
              {currentPurchase.city} compró{' '}
              <span className="font-semibold text-green-700" data-id="element-294">Dominando Shopify</span>
            </p>
            <p className="text-gray-500 text-xs mt-1" data-id="element-295">Hace unos minutos</p>
          </div>
          <button onClick={() => setIsVisible(false)} className="text-gray-400 hover:text-gray-600" data-id="element-296">
            <XIcon className="w-5 h-5" data-id="element-297" />
          </button>
        </div>
      </div>
    </div>;
}